import { Overlay, Portal } from '@cko/primitives';
import React, { useCallback, useState } from 'react';
import settings from 'services/app-settings';
import { AccountSelectorDialog, AccountSelectorButton } from './components';

export const AccountSelector = () => {
  const [open, setOpen] = useState(false);
  const onClick = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const usersApiBasePath = settings.api.userManagementApiBasePath;
  return (
    <>
      <AccountSelectorButton onClick={onClick} />
      {open && (
        <Portal>
          <Overlay
            onClick={() => setOpen(false)}
            style={{
              justifyContent: 'flex-start',
            }}
          >
            <AccountSelectorDialog
              usersApiBasePath={usersApiBasePath}
              closeMenu={() => setOpen(false)}
            />
          </Overlay>
        </Portal>
      )}
    </>
  );
};
